import run_iterable from "workerpool/run_iterable"

// Takes a list or [{url, page}, ...] a single blob url

export default async (generator, ...args) => {
  return run_iterable(["pdf", "merge_pdf", generator], ...args)
    .next()
    .then(({ value }) => value)
}
